import React from 'react'
import { BrowserRouter as Router,Switch, Route, Link } from 'react-router-dom'; 
import {FaSun, FaMoon, FaCog} from 'react-icons/fa'

function BottomFooter(props) {
    return (
        <div className="footer">
           
           <div className="container">
              <p>© Project X. 2021</p>
            
               <ul className="navbar-nav mr-auto">
                  <li className="nav-item active">
                  <Link className="nav-link" to="/">Home</Link>    
                  </li>
                  <li className="nav-item">
                  <Link className="nav-link"  to="/about">About</Link>    
                  </li>
                  <li className="nav-item">
                  <Link className="nav-link" to="/share">Share</Link>    
                  </li>
                  
                  <li className="nav-item">
                  <Link className="nav-link"  to="/submit">Submit a Website</Link> 
                  </li>
                </ul>
           
              
           </div>
        </div>
    )
}

export default BottomFooter;
